import React, {useEffect, useState} from 'react';
import "../App.css"
import {Link, ListItemIcon, ListItemText, Paper, Typography} from "@mui/material";
import MUIButton from "@mui/material/Button";
import {storage} from "../utils/localstorage";
import GoogleIcon from '@mui/icons-material/Google';
import CheckIcon from '@mui/icons-material/Check';

import css from "../css/main.module.css";
import {onAuthStateChanged, signInWithPopup} from "firebase/auth";
import {auth, provider} from "../firebase";
import {useNavigate} from "react-router-dom";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import {postInvoice} from "../utils/post";

export const VKLogo = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="13 15 24 24" width={22} height={22}>
    <path fill="#fff"
          d="M25.91 33c-7.18 0-11.29-4.91-11.47-13h3.82c.13 5.68 2.62 8.14 4.62 8.6V20h3.65v5.86c2-0.22 4.1-2.59 4.81-5.86h3.52c-0.55 3.13-2.8 5.5-4.34 6.45 1.54 0.74 4 2.65 4.72 6.55h-3.94c-0.8-3.07-2.79-4.58-5.42-4.83V33z"/>
</svg>

export const TGLogo = () => <svg xmlns="http://www.w3.org/2000/svg" viewBox="4 4 18 18" width={22} height={22}>
    <path fill="#fff"
          d="M17.95 7.64l-2.35 9.96c-.16.7-.61.87-1.23.54l-3.4-2.51-1.64 1.58c-.18.18-.33.33-.67.33l.24-3.38 6.16-5.57c.27-.24-.06-.37-.42-.14l-7.6 4.78-3.27-1.02c-.7-.22-.71-.7-.15-.93l12.82-4.94c.6-.22 1.12.14.93.92z"/>
</svg>

const Button = ({id, url, icon, text, onClick}) => {
    url = url && `${url}${btoa(encodeURIComponent(JSON.stringify({leadId: storage("leadId")})))}`;
    return (
        <Link onClick={onClick} href={url} underline="none">
            <MUIButton
                id={id}
                size={"large"}
                color="primary"
                startIcon={icon}
                variant="contained"
                sx={{justifyContent: "flex-start", width: "100%"}}
            >
                {text}
            </MUIButton>
        </Link>
    )
}

const Courses = () => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        postInvoice({method: "courses"}).then(setItems);
    }, [])

    return (
        <List sx={{width: '100%', maxWidth: 360, bgcolor: 'background.paper'}}>
            {items.map(item => (
                <ListItem key={item.text} disablePadding>
                    <ListItemIcon>
                        <CheckIcon/>
                    </ListItemIcon>
                    <ListItemText primary={item.text}/>
                </ListItem>
            ))}
        </List>
    )
}

export const Main = () => {
    const navigate = useNavigate();

    useEffect(() => {
        return onAuthStateChanged(auth, async user => user && navigate("/app"))
    }, [])

    return (
        <div className={css.main} style={{overflow: "auto"}}>
            <Paper className={css.paper} elevation={3} sx={{p: 4}}>
                <Typography variant={"h3"} gutterBottom>
                    Подготовка к экзамену
                </Typography>

                <Courses/>

                <div className={css.buttons}>
                    <Button
                        id="openAppButton"
                        text="Открыть приложение Telegram"
                        icon={<TGLogo/>}
                        //url="https://t.me/MathemOrgBot?startapp="
                        url="tg://resolve?domain=MathemOrgBot&startapp="
                    />

                    <Button
                        id="openAppButton"
                        text="Открыть приложение BK"
                        icon={<VKLogo/>}
                        url="https://vk.com/app53687294#"
                    />

                    <Button
                        id="openAppButton"
                        text="Авторизоваться через Google"
                        icon={<GoogleIcon/>}
                        onClick={() => signInWithPopup(auth, provider)}
                    />

                </div>
            </Paper>
        </div>
    );
}

